import { districtAddApi } from "../../api/district/districtAddApi"

type PayloadShape = Parameters<typeof districtAddApi>[0]

export async function districtAddService(payload: PayloadShape, token: string) {
	return await districtAddApi(payload, token)
}
